{
  "lang":[
    [
      "en",
      "English",
      "🇬🇧",
      "gb"
    ],
    [
      "ru",
      "Русский",
      "🇷🇺",
      "ru"
    ],
    [
      "zh",
      "中文",
      "🇨🇳",
      "cn"
    ],
    [
      "ko",
      "한국어",
      "🇰🇷",
      "kr"
    ],
    [
      "ja",
      "日本語",
      "🇯🇵",
      "jp"
    ],
    [
      "it",
      "Italiano",
      "🇮🇹",
      "it"
    ],
    [
      "fr",
      "Français",
      "🇫🇷",
      "fr"
    ],
    [
      "tr",
      "Türkçe",
      "🇹🇷",
      "tr"
    ],
    [
      "uk",
      "Українська",
      "🇺🇦",
      "ua"
    ]
  ],
  "x_partner": "kirsan1",
  "webapp": "webapp",
  "devDomains":[
    "50x",
    "terminal",
    "terminal.net.ru"
  ],
  "defaultCurrency":[
    "BTC",
    "USDT"
  ],
  
  "lastMaterKeyChars": 5,
  "name":"50x.com",
  "email":"support@50x.com",
  "advCash":{
    "receive" : "TUSDT",
    "currencies":[
      "USD",
      "RUR",
      "EUR"
    ],
    "depositMethods":[
      "ADVANCED_CASH",
      "VISA",
      "MASTERCARD"
    ]
  },
  "urls":{
    "host":"https://50x.com",
    "pma":"https://pma.50x.com",
    "terms":"https://terms.50x.com",
    "api":"https://api.50x.com",
    "rates":"https://rates.50x.com",
    "fees":"https://fees.50x.com",
    "coinMarketCap":"https://coinmarketcap.com/exchanges/50x",
    "visualGraph":"https://visual.50x.com",
    "logo":"https://trade.50x.com/media/terminal-logo.svg",
    "partner":"https://go.50x.com/50x50",    
    "websocketAddress": "wss://stream.50x.com:443/stream"
  },
  "orderStates":{
    "opened":[
      0,
      1,
      2
    ],
    "positions":[
      5
    ],
    "history":[
      50,
      51,
      52,
      53,
      3,
      7
    ],
    "cancaleble":[
      1,
      2,
      5
    ],
    "editable":[
      1,
      2,
      3,
      5
    ]
  },
  "orderbook":{
    "decimals":{
      "rate":9,
      "volume":7,
      "sum":7
    },
    "avaragePriceVolumeCorrection":1.05
  },
  "transparenty":{
    "value":0.5,
    "rateFrom":100,
    "fromRatio":0.3
  },
  "marginCallPercent":120,
  "loanTermDays":7,
  "priceCopyOffset":1e-8,
  "cancelableState":[ 1, 2, 5 ],
  "historyState":[ 52, 7 ],
  "updateIntervals": { 
    "transactions": 15000,
    "lasttrades": 15000,
    "blotter": 15000,
    "market": 15000,
    "tradelog": 15000
  },
  "placeorderAttentionPercent": 5,
  "lightBackgroundForSymbolIcons":  ["XLM", "XRP", "ZRX", "ETH"],
  "pma": {
    "reward":[ 5, 7, 10, 12, 15, 18, 20, 25, 30, 35, 40, 45, 50],
    "maxDD":[25, 30, 35, 40, 45, 50, 60, 70, 80], 
    "minDeposit":[1e-8, 1e-7, 0.000001, 0.00001, 0.0001, 0.001, 0.01, 0.1, 1, 10, 100, 1000, 10000, 100000, 1000000, 10000000],
    "minDepositInA2A":10,
    "botOrManual":[ 1, 2, 3],
    "crossTrading":[ 0, 1 ],
    "disclosureLevel":[ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    "lockupPeriod":[ 2, 4, 7, 14, 30, 60, 90, 180, 360 ],
    "profitDistributionCycle":[ 7, 14, 30, 60, 90, 180, 360],
    "referralGiveaway":[ 1, 2, 3, 5, 7, 10, 12, 15, 18, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80],
    "allowStoploss":[ 0, 1],
    "marketProtectionLevel":[ 15, 12, 10, 8, 5, 3],
    "minOwnFunds":[ 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 18, 20]
  },


  "url":"https://50x.com",
  "coinMarketCapUrl":"https://coinmarketcap.com/exchanges/50x",
  "visualGraph":"https://visual.50x.com",
  "logoUrl":"https://trade.50x.com/media/terminal-logo.svg",
  "partnerUrl":"https://go.50x.com/50x50",
  "pmaurl":"https://pma.50x.com",
  "termsurl":"https://terms.50x.com",
  "apiurl":"https://api.50x.com",
  "feesurl":"https://fees.50x.com",
  "errorAsModal":[
    100100,
    29905,
    29906,
    29907,
    37033,
    37014,
    10025,
    90009
  ],
  "sessionLifetimeMin":5,
  "sessionLifetimeMax":43200,
  "withdrawalDelayMin":8,
  "withdrawalDelayMax":4320,
  
  "video":{
    "intro":{
      "en":"https://www.youtube.com/embed/bXLm8xLTdso",
      "ru":"https://www.youtube.com/embed/EJsyAqAi3YU"
    },
    "lessons":{
      "en":"https://www.youtube.com/channel/UCLvmnc1DGj1q7kyizSfOBaA?sub_confirmation=1",
      "ru":"https://www.youtube.com/channel/UCrZiblVx35085QqY_ED1OOQ?sub_confirmation=1"
    }
  }
}